const userHasPermission = (userPermission, permissionKey, permissionType) => {
  const activePermission =
    userPermission && userPermission[permissionKey]?.includes(permissionType);
  return activePermission;
};

export default userHasPermission;
